import React from "react";
import "./PersonalDetails.css";
import vendorimg from "../../../assets/Component 24.png";
import finkraft from "../../../assets/finkraft.png";
import  { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";


const PersonalDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
const { email } = state || {};
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    company: "",
    department: "",
    role: "",
  });

  console.log("email",email)

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error on input
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First name is required.";
    if (!formData.phone) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be exactly 10 digits.";
    }
    if (!formData.company) newErrors.company = "Company name is required.";
    if (!formData.department) newErrors.department = "Department is required.";
    if (!formData.role) newErrors.role = "Role is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
  
    // Add the email to formData
    const formDataWithEmail = { ...formData, email };
  
    try {
      const response = await axios.post("https://vendor-score.finkraftai.com/api/personal-details", formDataWithEmail);
      console.log("Success:", response.data);
      navigate("/dashboard");
      // Redirect or show success message here
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  

  return (
    <div className="login-page-main">
      <div className="login-container">
        <div className="logo">
          <img src={finkraft} alt="Logo" className="logo-img" />
        </div>

        <div className="personal-box">
          <h1 className="welcome-text">Personal Details</h1>
          <p className="subtitle">
            Kindly provide the following information and setup your account with us.
          </p>

          <form className="details-form" onSubmit={handleSubmit}>
            <div className="input-row">
              <div className="form-group">
                <label>
                  First Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter first name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  onKeyPress={(e) => {
                    if (/\d/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.firstName && <div className="error-msg">{errors.firstName}</div>}
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  placeholder="Enter last name"
                  name="lastName"
                  value={formData.lastName}
                  onKeyPress={(e) => {
                    if (/\d/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-group">
              <label>
                Phone No. <span className="required">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter your phone number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              {errors.phone && <div className="error-msg">{errors.phone}</div>}
            </div>

            <div className="form-group">
              <label>
                Company <span className="required">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter your company’s name"
                name="company"
                value={formData.company}
                onChange={handleChange}
              />
              {errors.company && <div className="error-msg">{errors.company}</div>}
            </div>

            <div className="input-row">
              <div className="form-group">
                <label>
                  Department <span className="required">*</span>
                </label>
                <select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                >
                  <option value="">Select department</option>
                  <option value="finance">Finance</option>
                  <option value="sales">sales</option>
                  <option value="marketing">Marketing</option>
                  <option value="product">Product</option>
                  <option value="operations">Operations</option>
                  <option value="others">Others</option>
                </select>
                {errors.department && <div className="error-msg">{errors.department}</div>}
              </div>

              <div className="form-group">
                <label>
                  Role <span className="required">*</span>
                </label>
                <select name="role" value={formData.role} onChange={handleChange}>
                  <option value="">Select Role</option>
                  <option value="manager">Manager</option>
                  <option value="executive">Executive</option>
                  <option value="intern">Intern</option>
                  <option value="others">Others</option>
                </select>
                {errors.role && <div className="error-msg">{errors.role}</div>}
              </div>
            </div>

            <button type="submit" className="continue-btn">
              Continue
            </button>
          </form>
        </div>
      </div>
      <div className="vendor-image-container">
        <img src={vendorimg} className="vendor-image" alt="Vendor Visual" />
      </div>
    </div>
  );
};

export default PersonalDetails;
